import styled, { css } from 'styled-components';
import { Box, ButtonAppearance, ButtonSize, Button, Avatar } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';

export const WorklistInfoStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  & > * {
    margin-bottom: ${({ theme }) => theme.spacings[300]};
  }
`;

export const WorklistItemStyled = styled(Box).attrs({
  py: { sm: '500' },
  px: { sm: '500' },
  justifyContent: { sm: 'space-between' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const AvatarRegularStyled = styled(Avatar)`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    margin-right: ${theme.spacings[400]};
    flex-shrink: 0;
  `}
`;

export const CrewMemberStyled = styled(Box).attrs({
  alignSelf: { sm: 'center' },
  flexDirection: { sm: 'column' },
  mx: { sm: '500' },
  flexShrink: { sm: '0' },
})`
  & > :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings[450]};
  }
  width: 25%; /*Fixed width is required to allow  commodity tag to take maximum width */
`;

//Wrapper element mainly used for passing data-testid and check existence of blocks
export const ContentStyled = styled.div`
  display: contents;
`;

export const ButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
  appearance: ButtonAppearance.SECONDARY,
})`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

interface LabelStyledProps {
  status: MilestoneStatusCode;
}
export const LabelStyled = styled.label<LabelStyledProps>`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
  ${({ theme, status }) => css`
    ${status == MilestoneStatusCode.APPROVED
      ? css`
          background-color: ${theme.colors.green[300]};
          color: ${theme.colors.green[900]};
        `
      : css`
          background-color: ${theme.colors.orange[300]};
          color: ${theme.colors.orange[800]};
        `}
    border: 1px solid ${theme.colors.grey[300]};
    border-radius: ${theme.radii[200]};
    padding-top: ${theme.spacings[400]};
    padding-bottom: ${theme.spacings[300]};
    padding-left: ${theme.spacings[300]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `}
`;
